"use client";

import { useTranslations } from "next-intl";
import { useScrollReveal } from "@/hooks/use-scroll-reveal";

const steps = [1, 2, 3] as const;

export function LandingHowItWorks() {
  const t = useTranslations("landing");
  const labelRef = useScrollReveal<HTMLDivElement>();
  const gridRef = useScrollReveal<HTMLDivElement>({
    animation: "fade-up",
    stagger: true,
    staggerInterval: 120,
  });

  return (
    <section className="py-24">
      <div className="mx-auto max-w-7xl px-6">
        {/* Section label */}
        <div className="mb-12 text-center" ref={labelRef}>
          <span className="mb-4 inline-block rounded-full border border-landing-border bg-landing-card px-16 py-5 text-2xl font-bold tracking-tight text-mint">
            {t("howItWorks.label")}
          </span>
        </div>

        {/* Steps */}
        <div className="grid gap-6 md:grid-cols-3" ref={gridRef}>
          {steps.map((step) => (
            <div
              key={step}
              className="landing-card rounded-2xl border border-landing-border bg-landing-card p-8"
            >
              <div className="mb-5 flex h-10 w-10 items-center justify-center rounded-full bg-mint/10 text-sm font-bold text-mint">
                {step}
              </div>
              <h3 className="mb-2 text-lg font-semibold text-ink">
                {t(`howItWorks.step${step}Title`)}
              </h3>
              <p className="text-sm leading-relaxed text-landing-muted">
                {t(`howItWorks.step${step}Description`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
